import { useEffect, useMemo, useState } from 'react';

export function usePlatformClassName(baseClass, platformClasses = {}) {
  const [platform, setPlatform] = useState('other');

  const getPlatform = () => {
    const platform = navigator?.platform?.toLowerCase();
    if (platform.includes('mac')) return 'mac';
    if (platform.includes('win')) return 'windows';
    return 'other';
  };

  useEffect(() => {
    const pf = getPlatform();
    setPlatform(pf);
  }, []);

  return useMemo(() => {
    return [
      baseClass,
      platform === 'mac' && platformClasses.mac,
      platform === 'windows' && platformClasses.windows,
    ]
      .filter(Boolean)
      .join(' ');
  }, [baseClass, platformClasses]);
}
